// @flow
import { useLocation } from 'react-router-dom';

import { STREAMING_PROJECTS_ROUTE_IDENTIFIER } from '../components/streaming-projects/constants';

export const useIsCE2 = () => {
  const { pathname } = useLocation();
  return pathname.includes(STREAMING_PROJECTS_ROUTE_IDENTIFIER);
};
